<template>
  <div>
    <div class="menu_box">
      <div class="dxauth_title">
        <img src="@/assets/image/auth/logo_white.png" class="auth_title_img" alt="" />

        大象·统一认证后台
        <!-- <span
          class="iconfont iconqiehuanxitong1 cut_menu"
          @click="cut_sys_show = true"
        ></span> -->
      </div>
      <transition name="slide-left">
        <div class="menu_box2" v-show="!menu_loading">
          <div class="menu_list">
            <Menu
              v-if="menu_show"
              ref="left_menu"
              :active-name="active_name"
              :open-names="open_active"
              @on-select="on_select"
              width="200px"
            >
              <Submenu :name="String(i)" v-for="(item, i) in menu_list" :key="i">
                <template #title>
                  <i
                    :class="'iconfont ' + item.icon"
                    :style="'font-size:' + item.icon_size + 'px'"
                  ></i>
                  {{ item.name }}
                </template>
                <MenuItem
                  :target="menu_target"
                  :to="child_item.path"
                  :replace="true"
                  :name="String(i) + '-' + String(child_index)"
                  v-for="(child_item, child_index) in item.item_list"
                  :key="child_index"
                >
                  <i
                    :class="'iconfont ' + child_item.icon"
                    :style="'font-size:' + child_item.icon_size + 'px'"
                  ></i>
                  {{ child_item.name }}
                  <Icon
                    v-show="child_item.is_lock"
                    type="ios-lock"
                    size="16"
                    :color="
                      active_name == String(i) + '-' + String(child_index)
                        ? '#0466dd'
                        : '#888'
                    "
                    class="lock_menu"
                  />
                </MenuItem>
              </Submenu>
            </Menu>
          </div>

          <div class="user_info_box">
            <div class="user_avatar" v-if="userinfo">
              <Avatar :src="userinfo.avatar" />
              <span class="user_name">{{ userinfo.name }}</span>
            </div>
            <div class="tongzhi_div">
              <a href="/user/index" target="_blank" class="bangzhu" title="切换个人中心">
                <Icon type="md-swap" style="margin-right: 3px; font-weight: 600" />切换
              </a>

              <Poptip>
                <div class="exit_txt">
                  <Icon type="md-power" />
                  退出登录
                </div>

                <template #content>
                  <div class="exit_txt_detail">真的要退出吗？</div>

                  <div class="affirm_quit_btn_box">
                    <div class="affirm_quit_btn" @click="quit_button">确认</div>
                  </div>
                </template>
              </Poptip>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- <Drawer
      height="130px"
      placement="top"
      :scrollable="false"
      :closable="false"
      v-model="cut_sys_show"
    >
      <div class="cut_sys_box">
        <div class="cut_title">切换系统</div>
        <div class="sys_cut_list">
          <div
            v-for="(item, i) in sys_list"
            :key="i"
            class="sys_cut_box"
            @click="click_sys(item, i)"
          >
            <div class="sys_img_box2" v-if="!item.sys_auth">
              <img :src="item.img" alt="" class="sys_icon_img" />
              <Icon type="md-lock" class="sys_lock_icon" />
            </div>
            <div class="sys_img_box" :style="'background:' + item.color" v-else>
              <img :src="item.img" alt="" class="sys_icon_img" />
            </div>
            <div class="sys_img_detail">
              {{ item.name }}
              <div v-if="item.current_cut" class="cut_up_icon">
                <Icon type="md-arrow-dropup" size="26" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Drawer> -->
  </div>
</template>

<script>
import { open_new_page, http } from "@/utils/http.js";
import { toRaw } from "vue";

import Push from "push.js";
export default {
  name: "my_menu",
  props: [],

  data() {
    return {
      menu_show: true,
      menu_target: "_self",
      active_name: "",
      open_active: [],
      userinfo: {},
      cut_sys_show: false,
      sys_list: [],
      menu_list: [],
      menu_loading: false,
    };
  },
  created() {
    // Push.Permission.request();
  },
  mounted() {
    // 获取用户数据
    this.get_user_data();
    // 获取菜单数据
    this.get_menu_data();
  },
  updated() {},

  watch: {
    open_active(value, oldValue) {
      // 第一个参数为新值，第二个参数为旧值，不能调换顺序
      this.menu_show = false;
      var that = this;
      setTimeout(function () {
        that.menu_show = true;
      }, 5);
    },
  },
  methods: {
    click_bangzhu() {
      this.$Notice.success({
        duration: 6,
        desc: "请点击【打开DingTalkScheme】按钮，打开钉钉交流",
      });
    },

    //获取菜单与系统数据
    request_menu_data() {
      var that = this;
      this.menu_loading = true;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/menu/menu_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.menu_list = res.data.menu_list;
            // 保存菜单信息
            localStorage.setItem("menu_list", JSON.stringify(that.menu_list));

            that.sys_list = res.data.sys_list;
            // 保存系统列表
            localStorage.setItem("sys_list", JSON.stringify(that.sys_list));

            // 更新菜单选项
            that.update_menu();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
          that.menu_loading = false;
        })
        .catch((res) => {
          that.menu_loading = false;
          console.log(res, "请求出错");
        });
    },

    get_user_data() {
      var userinfo = this.$cookies.get("admin_user_info");
      if (userinfo != "undefined") {
        this.userinfo = userinfo;
      }
    },

    // 获取菜单数据
    get_menu_data() {
      // 获取菜单数据
      this.request_menu_data();
    },

    on_select(e) {
      var select_menu = e.split("-");
      var current_item = toRaw(
        this.menu_list[Number(select_menu[0])]["item_list"][Number(select_menu[1])]
      );
      // if(current_item.is_lock){
      //   this.menu_list[Number(select_menu[0])]['item_list'][Number(select_menu[1])]['path'] = '/page_403'
      // }
    },

    //更新菜单选中列
    update_menu() {
      var current_path = this.$route.path;
      var ment_list = toRaw(this.menu_list);
      if (!ment_list) {
        return;
      }

      for (let i = 0; i < ment_list.length; i++) {
        var menu_item = toRaw(this.menu_list[i]);
        for (let x = 0; x < menu_item["item_list"].length; x++) {
          if (menu_item["item_list"][x]["path"] == current_path) {
            this.active_name = String(i) + "-" + String(x);
            this.open_active = [String(i)];
            return;
          }
        }
      }
    },

    //点击切换系统
    click_sys(item, i) {
      if (item.sys_auth) {
        var url = item.url;
        open_new_page(url, "_blank");
      } else {
        this.$Message.error("没有这个系统登录权限");
      }
    },

    //确认退出
    quit_button() {
      this.$cookies.remove("admin_token");
      this.$cookies.remove("admin_private_key");
      this.$cookies.remove("admin_public_key");
      this.$cookies.remove("admin_user_info");
      this.$router.push({
        path: "/admin_login",
      });
    },
  },
};
</script>

<style scoped>
.sys_img_box2 {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  color: #909090;
  background: #ccc;
  border: 2px solid #fff;
  position: relative;
}

.sys_lock_icon {
  font-size: 26px;
  position: absolute;
  color: #093366;
}

.sys_icon_img {
  width: 35px;
  height: 35px;
}

.bangzhu {
  margin-right: 10px;
  color: #888;
  font-size: 13px;
}

.bangzhu:hover {
  color: #3482e1;
}

.menu_list {
  height: calc(100vh - 145px);
}

.menu_box2 {
  width: 200px;
}

.lock_menu {
  position: absolute;
  right: 25px;
  line-height: 30px;
}

/* 切换系统 */

.drawer_class {
  border-radius: 0 0 100px 100px;
}

.sys_cut_box {
  text-align: center;
  margin: 0 15px;
  cursor: pointer;
}

.sys_cut_list {
  width: calc(100% - 120px);
  display: flex;
  align-items: center;
  overflow: auto;
}

.cut_title {
  font-size: 13px;
  border-radius: 199px;
  font-weight: 300;
  background-color: #f7f7f7;
  border: 1px solid rgb(236, 236, 236);
  color: rgb(173, 173, 173);
  width: 100px;
  height: 36px;
  line-height: 33px;
  text-align: center;
  position: relative;
  top: -10px;
  flex-shrink: 0;
}

.cut_sys_box {
  padding-top: 20px;
  height: 90px;
  display: flex;
  align-items: center;
}

.sys_img_detail {
  font-size: 14px;
  color: #ccc;
  margin-top: 10px;
  text-align: center;
}

.sys_img_detail_select {
  color: #333;
  font-size: 14px;
  margin-top: 10px;
  font-weight: 600;
  text-align: center;
}

.sys_img_box {
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  color: #fff;
  border: 2px solid #fff;
}

.sys_img_box:hover {
  border: 2px solid #ddd;
}

.cut_menu {
  margin-left: 10px;
  cursor: pointer;
  font-weight: 300;
}

/*  */

/* 用户信息栏 */

.exit_txt_detail {
  margin-bottom: 10px;
}

.affirm_quit_btn_box {
  display: flex;
  justify-content: flex-end;
}

.affirm_quit_btn {
  background: #c90202;
  color: #fff;
  width: 60px;
  text-align: center;
  border-radius: 3px;
  font-size: 12px;
  padding: 3px 5px;
  cursor: pointer;
}

.exit_txt {
  color: #888;
  cursor: pointer;
  font-size: 13px;
}

.exit_txt:hover {
  color: #ff0000;
}

.user_name {
  margin-left: 10px;
  font-weight: 400;
}

.user_avatar {
  display: flex;
  align-items: center;
}

.tongzhi_div {
  margin-top: 3px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.user_info_box {
  padding: 10px;
  border-top: 1px solid #ececec;
}

/* 用户信息栏end */

.menu_box {
  height: 100vh;
  background: #fff;
  width: 199px;
}

.auth_title_img {
  width: 25px;
  height: 25px;
  margin-right: 5px;
}

.dxauth_title {
  letter-spacing: 3px;
  font-weight: 600;
  font-size: 14px;
  width: 199px;
  text-align: center;
  padding: 20px 10px;
  color: #fff;
  background-color: #0466dd;
  display: flex;
  align-items: center;
}
</style>
